export function getStripeCustomerLink(stripeId: string) {
  return `https://dashboard.stripe.com/customers/${stripeId}`
}

export function getStripeSubscriptionLink(subscriptionId: string) {
  return `https://dashboard.stripe.com/subscriptions/${subscriptionId}`
}

export function getAuth0UserLink(userId: string) {
  return `https://manage.auth0.com/dashboard/eu/hivemq-cloud/users/${userId}`
}

export function getSalesforceAccountLink(accountId: string) {
  return `https://hivemq.lightning.force.com/lightning/r/Account/${accountId}/view`
}
